import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions from '../redux/actions'

import Alert from '../views/alert/alert'

class AlertsController extends Component {

	render() {

		const alertCloseHandler = id => {
			this.props.actions.closeMessage(id, 'alert')
		}

		const alertLength = this.props.alert.array.length

		if (alertLength) {
			const alertElement = this.props.alert.array[alertLength-1]
			return (
				<Alert
					singleButton={alertElement.singleButton}
					closeOnAction={alertElement.closeOnAction}
					buttons={alertElement.buttons}
					onAlertClose={alertCloseHandler}
					alertId={alertElement.uid}
					alertTitle={alertElement.alertTitle}
					alertMessage={alertElement.alertMessage}
					alertImage={alertElement.alertImage}
				/>
			)
		} else {
			return null
		}
	}

}

AlertsController.propTypes = {
	actions: PropTypes.object,
	alert: PropTypes.object,
}

function mapStateToProps(state) {
	return { alert: state.alert }
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertsController)
